import { IconButton as ChakraIconButton, IconButtonProps } from '@chakra-ui/react/button'
import * as React from 'react'
import { LuX } from 'react-icons/lu'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _nullishCoalesce(lhs: any, rhsFn: () => any) {
  if (lhs != null) {
    return lhs
  } else {
    return rhsFn()
  }
}

export const CloseButton = React.forwardRef(function CloseButton(
  props: IconButtonProps,
  ref: React.Ref<HTMLButtonElement>,
) {
  return (
    <ChakraIconButton variant="ghost" aria-label="Close" ref={ref} {...props}>
      {_nullishCoalesce(props.children, () => (
        <LuX />
      ))}
    </ChakraIconButton>
  )
})
